import BaseResource                    from '@/lib/data/resource/BaseResource'
import dayjs                           from 'dayjs'
import { toNumberFormatNotationShort }      from '@/lib/utils/helper'
import i18n                            from '@/lang/lang'

export default class RiskPastAnalysesResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Id = payload.analysisId ?? ''
    this.Name = payload.analysisName ?? ''
    this.BaseCurrency = payload.baseCurrency ?? null
    this.CreatedAt = payload.createdAt ?? ''
    this.CreatedAtFmt = this.getDateFmt(payload.createdAt ?? '')
    this.PieItemCodes = payload.pieItemCodes ?? []
    this.PieItems = payload.pieItems ?? []
    this.IsDefault = payload.default ?? false
    this.IsActive = payload.active ?? false
    this.NIIRisk = payload.niiRisk ?? ''
    this.ValueDate = payload.valueDate ?? ''
    this.ValueDateFmt = i18n.t('Common.Date.Selector.Label') + ' ' + this.getPortfolioDateFmt(this.ValueDate)
    this.TitleValue = this.NIIRisk ? this.BaseCurrency.displaySymbol + toNumberFormatNotationShort(this.NIIRisk) : ''
  }

  /* PROPERTIES */

  get PieValues () {
    if (this.PieItems) {
      return this.PieItems.map(item => {
        return {
          name : item.itemCode,
          label: item.label,
          value: item.value,
          type : 'number'
        }
      })
    }

    return []
  }

  /* METHODS */
  getDateFmt (date) {
    return date ? dayjs(date).format('DD MMM YYYY') : ''
  }

  getPortfolioDateFmt (date) {
    return date ? dayjs(date).format('MMMM DD, YYYY') : ''
  }
}
